/**
 * @generated SignedSource<<29bed2df6486126a6e46a07b0faeb969>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_FullPageIssueApp$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly key: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueAppWithData">;
  readonly " $fragmentType": "main_issueNavigator_FullPageIssueApp";
};
export type main_issueNavigator_FullPageIssueApp$key = {
  readonly " $data"?: main_issueNavigator_FullPageIssueApp$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_FullPageIssueApp">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_FullPageIssueApp",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueAppWithData"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "90ab50f7eff82875c494c7112616f0e5";

export default node;
